import { useNavigate, useParams } from 'react-router-dom';

import ROIForm from '@/forms/ROIForm';
import Container from '@/ui/components/Container';

const NewROI = () => {
  const navigate = useNavigate();
  const { personId } = useParams();

  const goBack = () => {
    if (personId) {
      navigate(`/people/${personId}/documents`);
      return;
    }
    navigate(-1);
  };

  return (
    <Container type="page">
      <ROIForm onSuccess={goBack} />
    </Container>
  );
};

export default NewROI;
